import { flow } from 'lodash';
import { mapPreviewSelector, mapMultiPreviewSelector, makeNullSafeDomainGetter, makeByIdsDictionarySelector } from './common';
import { IBulletin, IProject } from 'utils/entities';


const searchSelector = makeNullSafeDomainGetter(mapPreviewSelector, 'poiByIds');
const searchMultiSelector = makeNullSafeDomainGetter(mapMultiPreviewSelector, 'poiByIds');

const EMPTY: Array<IBulletin | IProject> = [];

export const mapPreviewPoiListSelector = flow(searchSelector, (poiByIds) => (poiByIds || EMPTY));
export const mapMultiPreviewPoiListSelector = flow(searchMultiSelector, (poiByIds) => (poiByIds || EMPTY));

export const mapPreviewPoisDictionarySelector = makeByIdsDictionarySelector(mapPreviewPoiListSelector);
